"use client";
import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import ExpandIcon from "@mui/icons-material/ExpandMoreRounded";
import SendIcon from "@mui/icons-material/SendRounded";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/EmailRounded";

import { a11yProps } from "./BookOnlineCruiseDeals";
import { PhoneCallingIcon } from "../icons/PhoneCallingIcon";
import EnquiryForm from "../common/EnquiryForm";

const HomeFAQs: React.FC = () => {
  const [selectedtab, setSelectedtab] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedtab(newValue);
  };

  return (
    <Box>
      <Container>
        <Box sx={{ mt: "3rem", mb: "3rem" }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3.2rem" },
              fontWeight: { xs: 800, md: 700 },
              textAlign: "center",
              color: "primary.main",
              lineHeight: { xs: 1.1, md: 1.3 },
              mb: { xs: "10px", md: "0px" },
              span: {
                color: "transparent",
                WebkitTextStrokeColor: "#CE0000",
                WebkitTextStrokeWidth: "1px",
              },
            }}
          >
            Frequently Asked <span>Questions</span>
          </Typography>
          <Box
            sx={{
              fontSize: { xs: "14px", md: "1rem" },
              fontWeight: 400,
              lineHeight: { xs: 1.4, md: 1.3 },
              textAlign: "center",
              mb: { xs: "1.6rem", md: "1.5rem" },
            }}
          >
            {/* Everything You Need to Know Before You Set Sail! */}
            Curious About Your Cruise? Find Answers Here
          </Box>
        </Box>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 7.2, lg: 7.6, xl: 8 }}>
            <Box>
              <Tabs
                value={selectedtab}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                  transitions: "all 0.5s",
                  ".MuiTabs-root": {
                    boxShadow: "0px 0px 10px 0px #06027377",
                    overflow: "hidden",
                  },
                  ".MuiTabs-flexContainer": {
                    // bgcolor: "#EDF1FF",
                    borderRadius: "10px",
                    gap: "9px",
                    transition: "all 0.5s",
                    ".MuiButtonBase-root.MuiTab-root": {
                      border: "1px solid #06027377",
                      textTransform: "initial",
                      borderRadius: "25px",
                      fontWeight: 700,
                      transitions: "all 0.5s",
                      color: "primary.main",
                      fontFamily: "'blauerNue', 'blauerNue Fallback'",
                      fontSize: "15px",
                      p: "5px 18px",
                      "&.Mui-selected": {
                        bgcolor: "primary.main",
                        color: "#fff",
                      },
                      "&:hover": {
                        bgcolor: "#000",
                        color: "#fff",
                      },
                    },
                  },
                  ".MuiTabs-indicator": {
                    display: "none",
                  },
                  ".MuiButtonBase-root.MuiTabScrollButton-root.MuiTabs-scrollButtons": {
                    // bgcolor: "#5900FF",
                    bgcolor: "#060273",
                    color: "#fff",
                    opacity: 1,
                    borderRadius: "10px",
                    width: "35px",
                    transitions: "all 0.5s",
                    svg: {
                      width: "35px",
                      height: "35px",
                      p: "2px 0px 0px",
                    },
                    "&:nth-of-type(1)": {
                      borderRadius: "10px 0px 0px 10px",
                    },
                    "&:nth-of-type(4)": {
                      borderRadius: "0px 10px 10px 0px",
                    },
                    "&.Mui-disabled": {
                      opacity: 0,
                      width: "0px",
                    },
                  },
                }}
              >
                {faqData.map((faq, faqI) => (
                  <Tab
                    key={faqI}
                    label={faq.section}
                    {...a11yProps("faq", faqI)}
                    onClick={() => {
                      setSelectedtab(faqI);
                    }}
                  />
                ))}
              </Tabs>
            </Box>
            <Box
              sx={{ mt: "2rem" }}
              role="tabpanel"
              id={`faq-tabpanel-${selectedtab}`}
              aria-labelledby={`faq-tab-${selectedtab}`}
            >
              {faqData[selectedtab].data.map((x, xi) => (
                <QAndAUI
                  key={xi}
                  question={x.question}
                  answer={x.answer}
                  defaultExpanded={xi == 0}
                />
              ))}
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 4.8, lg: 4.4, xl: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: "16px", md: "20px" },
                height: "100%",
                mt: { xs: "0px", sm: "1rem", md: "0px" },
              }}
            >
              <Box
                sx={{
                  height: { xs: "1px", md: "100%" },
                  width: { xs: "100%", md: "1px" },
                  bgcolor: "#ccc",
                  display: { xs: "block", sm: "none", md: "block" },
                }}
              ></Box>
              <Box
                sx={{
                  display: { xs: "grid", md: "block" },
                  placeItems: { xs: "center", md: "unset" },
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    background: "-webkit-linear-gradient(#42009E, #0700BE)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontSize: { xs: "2rem", md: "2.2rem" },
                    fontWeight: 700,
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                    mb: "1.5rem",
                    width: { xs: "100%", sm: "500px", md: "100%" },
                    textAlign: { xs: "left", sm: "center", md: "left" },
                  }}
                >
                  Have a Customized Request? Contact Us for Special Deals!
                </Box>

                <Box>
                  <HomeContactButtons />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HomeFAQs;

const QAndAUI: React.FC<{
  question: string;
  answer: string | React.ReactNode;
  defaultExpanded?: boolean;
}> = ({ question, answer, defaultExpanded }) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      sx={{
        mb: "1rem",
        borderRadius: "16px",
        boxShadow: "0px 0px 16px rgba(0,0,0,0.18)",
        "&:first-of-type": {
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
        },
        "&:last-of-type": {
          borderBottomLeftRadius: "16px",
          borderBottomRightRadius: "16px",
        },
        "&::before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandIcon />}
        sx={{
          fontWeight: 700,
          fontFamily: "'blauerNue', 'blauerNue Fallback'",
          fontSize: "18px",
          ".MuiAccordionSummary-content": {
            my: "20px",
          },
          ".MuiAccordionSummary-expandIconWrapper > svg": {
            fontSize: "35px",
            fill: "#000",
          },
        }}
      >
        {question}
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            fontSize: "15px",
            color: "#666",
            fontWeight: 400,
            borderTop: "1px solid #ddd",
            pt: "14px",
            mt: "-12px",
            "& ul": {
              paddingLeft: "20px",
              margin: "10px 0",
            },
            "& li": {
              marginBottom: "8px",
            },
          }}
        >
          {typeof answer === "string" ? (
            <div dangerouslySetInnerHTML={{ __html: answer }} />
          ) : (
            answer
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export const HomeContactButtons: React.FC = () => {
  const [openEnquiryForm, setOpenEnquiryForm] = useState<boolean>(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: "1.2rem", md: "1.8rem" },
        fontFamily: "'blauerNue', 'blauerNue Fallback'",
        ".contact-btn-wrapper": {
          color: "#fff",
          fontSize: { xs: "1.2rem", md: "1.6rem" },
          fontFamily: "'blauerNue', 'blauerNue Fallback'",
          fontWeight: 700,
          lineHeight: 1.3,
          height: { xs: "56px", md: "65px" },
          width: { xs: "100%", sm: "500px", md: "100%" },
          textTransform: "initial",
          gap: "10px",
          display: "flex",
          justifyContent: "space-between",
          pl: { xs: "90px", md: "108px" },
          textAlign: "left",
          svg: {
            width: { xs: "30px", md: "35px" },
            height: { xs: "30px", md: "35px" },
          },
        },
        ".contact-btn-icon": {
          width: { xs: "65px", md: "78px" },
          height: { xs: "65px", md: "78px" },
          position: "absolute",
          top: { xs: "-6px", md: "-8px" },
          left: { xs: "13px", md: "17px" },
          display: "grid",
          placeItems: "center",
          borderRadius: "50%",
          border: { xs: "1.5px solid #fff", md: "3px solid #fff" },
          color: "#fff",
        },
        ".btn-label-one": {
          fontSize: { xs: "15px", md: "17px" },
          mt: "3px",
          mb: "-4px",
          fontWeight: 600,
        },
      }}
    >
      <Button
        href="tel:+442081253546"
        target="_blank"
        className="contact-btn-wrapper"
        sx={{
          background: "linear-gradient(90deg, #0300B3 0%, #0086FB 74%)",
          border: "1px solid #02009060",
        }}
      >
        <Box
          className="contact-btn-icon"
          sx={{
            bgcolor: "#0300AE",
            boxShadow: "0px 0px 15px #8987FF",
          }}
        >
          <PhoneCallingIcon />
        </Box>
        <Box>
          <Box className="btn-label-one" sx={{ ml: "1px" }}>
            Call Us Now
          </Box>
          <Box>020 8125 3546</Box>
        </Box>
      </Button>

      {/* <Button
        href="https://api.whatsapp.com/send?phone=447719184111&text=Hi,%20World%20Holiday%20Vibes"
        target="_blank"
        className="contact-btn-wrapper"
        sx={{
          background: "linear-gradient(90deg, #036000 0%, #5ECA72 74%)",
          border: "1px solid #00703A80",
        }}
      >
        <Box
          className="contact-btn-icon"
          sx={{
            bgcolor: "#037100",
            boxShadow: "0px 0px 15px #56D783",
            svg: {
              width: { xs: "35px !important", md: "35px" },
              height: { xs: "35px !important", md: "35px" },
            },
          }}
        >
          <WhatsAppIcon />
        </Box>
        <Box>
          <Box className="btn-label-one">WhatsApp</Box>
          <Box>020 8125 3546</Box>
        </Box>
      </Button> */}

      <Button
        className="contact-btn-wrapper"
        href="mailto:info@worldcruisevibes.com"
        target="_blank"
        sx={{
          background: "linear-gradient(90deg, #DB4200 0%, #F7A500 74%)",
          border: "1px solid #AF6C0080",
        }}
      >
        <Box
          className="contact-btn-icon"
          sx={{
            bgcolor: "#D74402",
            boxShadow: "0px 0px 15px #E89300",
          }}
        >
          <EmailIcon />
        </Box>
        <Box>
          <Box className="btn-label-one">Email</Box>
          <Box
            sx={{
              fontSize: { xs: "1rem", sm: "1.2rem", md: "1.05rem", lg: "1.1rem", xl: "1.3rem" },
            }}
          >
            Info@worldcruisevibes.com
          </Box>
        </Box>
      </Button>

      <Box sx={{ fontSize: "1.1rem", fontWeight: 700, my: "12px" }}>OR</Box>

      <Button
        sx={{
          fontSize: "1.6rem",
          color: "#fff",
          background: "linear-gradient(180deg, rgba(66,0,158,1) 0%, rgba(7,0,190,1) 74%)",
          fontFamily: "'blauerNue', 'blauerNue Fallback'",
          width: { xs: "100%", sm: "500px", md: "100%" },
          textTransform: "initial",
          gap: "10px",
          svg: {
            width: "40px",
            height: "40px",
          },
        }}
        onClick={() => setOpenEnquiryForm(true)}
      >
        Get a Quote
        <SendIcon />
      </Button>
      <EnquiryForm open={openEnquiryForm} onClose={() => setOpenEnquiryForm(false)} />
    </Box>
  );
};

const faqData = [
  {
    index: 0,
    section: "Cruise Planning & Booking",
    data: [
      {
        question: "How do I book a cruise?",
        answer:
          "Speak to our dedicated World Cruise Vibes Experts for instant quotes and exclusive deals not found online. We offer personalised booking tips and in-depth product knowledge. Alternatively, explore our website featuring 40+ cruise lines, ship details, virtual tours, reviews, dining menus, and kids' program information to book your perfect holiday directly. ",
      },
      {
        question: "How much does a cruise holiday cost?",
        answer:
          "What you can afford for a cruise holiday may vary depending on the cruise line, where you go, and how long you stay. We have a range of choices to fit your tastes and budget, whether you want to take a short trip or a longer holiday. There are all kinds of cruises, from short, cheap trips to longer, fancier ones everyone can find the right one. We can help you find the perfect holiday no matter how much you want to spend or how cheap it is.",
      },
      {
        question: "What is the cheapest month to cruise?",
        answer: `<ul>
          <li><strong>Mid-January-early February</strong> - After the holidays, prices tend to go down.</li>
          <li><strong>End of February</strong> - Prices tend to go up around Valentine's Day, but they start to go down again at the end of the month.</li>
          <li><strong>Early May</strong> - Prices go down after spring break but before the kids leave for the summer.</li>
          <li><strong>Mid to late September</strong> - Prices tend to go down after Labour Day and stay that way for the rest of September.</li>
          <li><strong>Early December</strong> - Thanksgiving and Christmas are the busiest weeks of the year. If you want to save money, cruise between those two holidays.</li>
        </ul>`,
      },
      {
        question: "Which is the best cruise company to travel with?",
        answer:
          "There is no one best cruise line; it depends on how you like to travel, where you want to go, and your preferences. Some cruise companies are known for their high-end services, family-friendly fun, cultural enrichment, and great value. Some cruise lines also focus on certain areas, like the Mediterranean, the Caribbean, or European river trips. Here at World Cruise Vibes, we help you find the best cruises based on your wants, needs and price. We make sure that every trip is perfect for you.",
      },
      {
        question: "How long is a cruise? ",
        answer: `Cruise lengths vary greatly, from short 2-night UK tours to extensive 100-day world voyages. UK departures for Europe/Mediterranean in summer typically last 5-17 days. Winter Caribbean/Canary Island cruises are longer, averaging 9-21 days. Fly cruises offer global flexibility in duration, and "Cruise and Stay Holidays" options combine sailing with extended land stays. `,
      },

      {
        question: "What is a cruise holiday?",
        answer:
          "A cruise holiday entails travelling to many ports of call. It offers a handy method to experience other areas without having to pack everything again since it integrates transport, housing, dining, and entertainment into one package.",
      },
    ],
  },
  {
    index: 1,
    section: "Destinations & Cruise Types",
    data: [
      {
        question: "Which country is best for a cruise?",
        answer:
          "Unsurprisingly, cruises to the Caribbean are the most popular in the world. To many, the perfect tropical holiday includes lively cultures, great music, beautiful beaches, abundant watersports, and warm weather. Since there is a wide variety of activities, the Caribbean is perfect for couples, honeymooners, and large groups of friends. But we can make every country the best with our last minute cruise deals.",
      },
      {
        question: "Why should I choose a cruise holiday?",
        answer:
          "Cruising's image is evolving, becoming more accessible and affordable. Packing once, travellers explore multiple cruise destinations with onboard entertainment, diverse dining, and varied accommodations for different budgets. Enjoy Broadway shows, casinos, themed bars, and more in a floating hotel. World Cruise Vibes experts ensure the best possible deals.",
      },
    ],
  },
  {
    index: 2,
    section: "Packing & Preparation",
    data: [
      {
        question: "What to pack for a cruise holiday?",
        answer:
          "Pack your passport, cruise tickets, swimwear, casual clothes, evening wear (check dress code!), comfortable shoes, and sun protection. Don't forget medications and essential toiletries. A small carry-on for embarkation day is also recommended. Check your cruise line's specific guidelines with us!",
      },
    ],
  },
  {
    index: 3,
    section: "Onboard Experience & Entertainment",
    data: [
      {
        question: "What entertainment is available at night?",
        answer: `Evening entertainment on cruises offers diverse options, from spectacular Broadway-style productions with cutting-edge technology on larger ships (like Royal Caribbean and P&O) to cosy piano bars and live music on smaller ones. Some lines feature renowned shows (e.g., "The Blue Man Group"). Cunard uniquely has a resident theatre company and performances by RADA actors. Enjoy casinos and outdoor movie nights as well. Our Cruise Experts can tailor your trip to your entertainment preferences.`,
      },
    ],
  },
];
// const faqData = [
//   {
//     index: 0,
//     section: "Booking & Reservations",
//     data: [
//       {
//         question: "How do I book a cruise?",
//         answer:
//           "Simply search for your desired destination, select your travel dates, choose your preferred cruise, and complete your booking with our secure payment options.",
//       },
//       {
//         question: "Can I make changes to my booking?",
//         answer:
//           "Yes! You can modify your travel dates, upgrade your cabin, or make other changes depending on the cruise line’s policy. Contact our support team for assistance.",
//       },
//       {
//         question: "Can I book multiple cabins at once?",
//         answer:
//           "Absolutely! You can book multiple cabins for family or group travel in one reservation. If you need special arrangements, our support team can help.",
//       },
//       {
//         question: "How far in advance should I book my cruise?",
//         answer:
//           "For the best deals and availability, we recommend booking at least 6–12 months in advance, especially for peak seasons and popular routes.",
//       },
//       {
//         question: "Do I need a visa or passport for my cruise?",
//         answer:
//           "Travel requirements depend on your cruise destination. Some international cruises require a valid passport and visa. Always check with your cruise line or local authorities before booking.",
//       },
//       {
//         question: "What is included in the cruise fare?",
//         answer:
//           "Most cruises include accommodations, meals, onboard entertainment, and access to pools and fitness centers. Additional services like specialty dining, excursions, and spa treatments may have extra charges.",
//       },
//       {
//         question: "How early should I arrive for my cruise?",
//         answer:
//           "It’s recommended to arrive at the port at least 2–3 hours before departure to allow time for check-in, security, and boarding procedures.",
//       },
//       {
//         question: "How do I stay connected on board?",
//         answer:
//           "Most cruise lines offer onboard Wi-Fi packages. Some premium suites may include free internet access. Check with your cruise provider for Wi-Fi pricing and availability.",
//       },
//     ],
//   },
//   {
//     index: 1,
//     section: "Payments & Discounts",
//     data: [
//       {
//         question: "What payment methods do you accept?",
//         answer:
//           "We accept Apple Pay, Google Pay, Klarna, Super Pay, Visa, Maestro, Mastercard, and PayPal for secure and flexible payments.",
//       },
//       {
//         question: "Do you offer flexible payment plans?",
//         answer:
//           " Yes! Some cruise lines allow you to pay in installments. Klarna and other options may let you split payments over time.",
//       },
//       {
//         question: "Are there any additional booking fees?",
//         answer:
//           "No hidden fees! The total price you see includes all taxes and charges unless otherwise stated. Optional add-ons like excursions and dining upgrades are available at extra cost.",
//       },
//       {
//         question: "Do you offer discounts for seniors, military personnel, or first-time cruisers?",
//         answer:
//           "Yes! Many cruise lines offer special discounts for seniors, veterans, and first-time travelers. Check our deals page or contact us for eligibility.",
//       },
//     ],
//   },
//   {
//     index: 2,
//     section: "Deals & Special Offers",
//     data: [
//       {
//         question: "How can I find the best cruise deals?",
//         answer:
//           "Sign up for our newsletter and follow us on social media for exclusive discounts and flash deals on cruises!",
//       },
//       {
//         question: "Do you have last-minute cruise deals?",
//         answer:
//           "Yes! We frequently offer last-minute deals on select cruises. Keep an eye on our 'Last-Minute Deals' section for the latest offers.",
//       },
//       {
//         question: "Are there group discounts for families and friends?",
//         answer:
//           "Yes! We offer special group rates for family reunions, corporate retreats, and large bookings. Contact us for customized group pricing.",
//       },
//     ],
//   },
//   {
//     index: 3,
//     section: "Travel & Onboard Experience",
//     data: [
//       {
//         question: "Do I need a passport or visa to cruise?",
//         answer:
//           "It depends on your destination. Some international cruises require a passport and visa. Check travel requirements before booking.",
//       },
//       {
//         question: "What’s included in my cruise fare?",
//         answer:
//           "Your fare covers accommodation, meals, onboard entertainment, and most activities. Specialty dining, excursions, and spa treatments may have additional charges.",
//       },
//       {
//         question: "How early should I arrive for my cruise?",
//         answer:
//           "We recommend arriving at the port at least 2–3 hours before departure for check-in and security procedures.",
//       },
//       {
//         question: "How do I stay connected onboard?",
//         answer:
//           "Most cruise lines offer Wi-Fi packages. Check with your cruise provider for pricing and availability.",
//       },
//     ],
//   },
//   {
//     index: 4,
//     section: "Cancellations & Insurance",
//     data: [
//       {
//         question: "What is the cancellation policy?",
//         answer:
//           "Cancellation policies vary by cruise line. Some bookings may be refundable or offer credit for future travel. Check our policy details at checkout.",
//       },
//       {
//         question: "Can I get a refund if I cancel my trip?",
//         answer:
//           "Refund eligibility depends on how close you are to departure. Travel insurance can help cover unexpected cancellations.",
//       },
//       {
//         question: "Do you offer travel insurance?",
//         answer:
//           "Yes! We offer travel insurance options for trip cancellations, medical emergencies, and lost luggage. Add it at checkout for peace of mind.",
//       },
//     ],
//   },
// ];
